export default "{\n    \"title\": \"Planned Maintenance Estimate\",\n    \"subtitle\": \"Get estimates for recurring planned maintenance services\"\n}\n"